// extracted by mini-css-extract-plugin
module.exports = {"copyrights":"Copyrights_copyrights__Dzzg5","list":"Copyrights_list__yIbj0"};